import React from 'react';
import PropTypes from 'prop-types';

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import { Button } from '@telus-uds/components-web';
import Delete from '@telus-uds/palette-allium/build/web/icons/Delete';
import { Box, TopbarWrapper } from '../design/css';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { esChatDiscountProduct } from '../utils/constant';

const BusinessPlansTable = ({ businessAppPlans, onDelete, isDeletable }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    businessAppTable: { productLabel, monthlyChargesLabel, oneTimeChargesLabel , quantityLabel, deleteLabel },
    formButtons: { deleteButtonLabel }
  } = localizedStrings;
  const totlDevices = businessAppPlans.reduce((acc, item) => acc + +item.quantity, 0);

  // The global `table { table-layout: fixed }` sizes columns from the header row,
  // so without header widths every column gets an equal share and the product name
  // wraps into a narrow column. Widths sum to 100% for both layouts.
  const columnWidths = isDeletable
    ? { index: '6%', product: '38%', monthly: '18%', oneTime: '16%', quantity: '11%', delete: '11%' }
    : { index: '6%', product: '44%', monthly: '20%', oneTime: '18%', quantity: '12%' };
  // Global `body` line-height is 2em, which spreads wrapped lines too far apart.
  const cellStyle = { lineHeight: 1.4 };

  return (
    <Box
      style={{
        margin: '2rem 0',
        border: '1px solid #e3e3e3',
        boxShadow: '1px 1px 9px 4px #e3e3e3'
      }}
    >
      <TopbarWrapper
        style={{ color: '#fff' }}
      >{`Services (${totlDevices})`}</TopbarWrapper>
      <Table>
        <Thead style={{ background: '#e2e2e2' }}>
          <Tr>
            <Th style={{ width: columnWidths.index }}>#</Th>
            <Th style={{ width: columnWidths.product }}>{productLabel}</Th>
            <Th style={{ width: columnWidths.monthly, textAlign: 'center' }}>{monthlyChargesLabel}</Th>
            <Th style={{ width: columnWidths.oneTime, textAlign: 'center' }}>{oneTimeChargesLabel}</Th>
            <Th style={{ width: columnWidths.quantity, textAlign: 'center' }}>{quantityLabel}</Th>
            {isDeletable && <Th style={{ width: columnWidths.delete, textAlign: 'center' }}>{deleteLabel}</Th>}
          </Tr>
        </Thead>
        <Tbody>
          {businessAppPlans.map((item, index) => {
            const { name, monthlyCharges, oneTimeCharges , quantity } = item;
            const rowKey = `row${index}`;
            let updatePrice = '';
            if(esChatDiscountProduct.includes(name))
              updatePrice = 'Discounted Price';
            return (
              <Tr
                key={rowKey}
                style={{
                  background: index % 2 === 0 ? '#f9f1ff' : '#ffffff'
                }}
              >
                <Td style={cellStyle}>{index + 1}</Td>
                <Td style={cellStyle}>{name}</Td>
                <Td style={{ ...cellStyle, textAlign: 'center' }}>{updatePrice || `$${monthlyCharges}`}</Td>
                <Td style={{ ...cellStyle, textAlign: 'center' }}>{`$${oneTimeCharges}`}</Td>
                <Td style={{ ...cellStyle, textAlign: 'center' }}>{quantity}</Td>
                {isDeletable && 
                <Td style={{ ...cellStyle, textAlign: 'center' }}>
                  <button
                    type="button"
                    className="btn btn-link"
                    style={{ color: '#4B286D', textDecoration: 'underline' }}
                    onClick={() => onDelete(index)}
                  >
                    {/* {deleteButtonLabel} */}
                    <Button
                      icon={Delete}
                      onPress={() => onDelete(index)}
                      accessibilityLabel="Delete"
                      variant={{ text: true }}
                    />
                  </button>
                </Td>
          }
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </Box>
  );
};

BusinessPlansTable.propTypes = {
    businessAppTable: PropTypes.arrayOf(
    PropTypes.shape({
        productLabel: PropTypes.string,
        monthlyChargesLabel: PropTypes.number,
        oneTimeChargesLabel: PropTypes.number,
        quantityLabel: PropTypes.number
    })
  ).isRequired,
  onDelete: PropTypes.func.isRequired
};

export default BusinessPlansTable;
